// extracted by mini-css-extract-plugin
module.exports = {"active_page":"style_active_page__138n9"};